import { Bell, AlertCircle, CheckCircle2, RefreshCw, Sparkles } from 'lucide-react';
export function NotificationCategoryIcon({ category, size = 16 }: { category: string; size?: number }) {
  const Icon = ({ upgrade: RefreshCw, problem: AlertCircle, recovery: CheckCircle2, feature: Sparkles } as Record<string, typeof Bell>)[category] || Bell;
  return <Icon size={size} />;
}
